(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yuvenlife-ap-home"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var page = document.querySelector("[data-ap-page]");
    if (!page) return;
    var header = page.querySelector("[data-ap-header]");
    var menu = page.querySelector("[data-ap-menu]");
    var nav = page.querySelector("[data-ap-nav]");
    if (!header || !menu || !nav) return;
    function closeMenu() {
      header.setAttribute("data-open", "false");
      menu.setAttribute("aria-expanded", "false");
    }
    menu.addEventListener("click", function () {
      var open = header.getAttribute("data-open") === "true";
      header.setAttribute("data-open", open ? "false" : "true");
      menu.setAttribute("aria-expanded", open ? "false" : "true");
    });
    nav.querySelectorAll("a,button").forEach(function (item) {
      item.addEventListener("click", closeMenu);
    });
  }());

  (function () {
    function placeProductBand() {
      var mobile = matchMedia("(max-width:820px)").matches;
      document.querySelectorAll("#kaufen .option-card").forEach(function (card) {
        var band = card.querySelector(".option-card__banderole");
        var media = card.querySelector(".option-card__media");
        if (!band || !media) return;
        var mediaHeight = media.offsetHeight;
        if (mobile) {
          if (band.parentElement !== media) media.appendChild(band);
          if (mediaHeight < 40) { band.style.opacity = "0"; return; }
          band.style.opacity = "1";
          band.style.position = "absolute";
          band.style.top = "auto";
          band.style.bottom = "0";
          band.style.left = "0";
          band.style.right = "0";
        } else {
          if (band.parentElement !== card) card.appendChild(band);
          if (mediaHeight < 40) { band.style.opacity = "0"; return; }
          band.style.opacity = "1";
          band.style.position = "absolute";
          band.style.top = (media.offsetTop + mediaHeight - band.offsetHeight * 0.62) + "px";
          band.style.bottom = "auto";
          band.style.left = "";
          band.style.right = "";
        }
      });
    }
    function initProductBand() {
      if ("ResizeObserver" in window) {
        document.querySelectorAll("#kaufen .option-card__media").forEach(function (media) {
          try { new ResizeObserver(placeProductBand).observe(media); } catch (error) {}
        });
      }
      document.querySelectorAll("#kaufen .option-card__media img").forEach(function (image) {
        image.addEventListener("load", placeProductBand);
        if (image.complete) placeProductBand();
      });
      placeProductBand();
    }
    if (document.readyState !== "loading") initProductBand();
    else addEventListener("DOMContentLoaded", initProductBand);
    addEventListener("load", placeProductBand);
    addEventListener("resize", placeProductBand);
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yuvenlife-ap"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var page = document.querySelector("[data-ap-page]");
    if (!page) return;
    var header = page.querySelector("[data-ap-header]");
    var menu = page.querySelector("[data-ap-menu]");
    var nav = page.querySelector("[data-ap-nav]");
    if (!header || !menu || !nav) return;
    function closeMenu() {
      header.setAttribute("data-open", "false");
      menu.setAttribute("aria-expanded", "false");
    }
    menu.addEventListener("click", function () {
      var open = header.getAttribute("data-open") === "true";
      header.setAttribute("data-open", open ? "false" : "true");
      menu.setAttribute("aria-expanded", open ? "false" : "true");
    });
    nav.querySelectorAll("a,button").forEach(function (item) {
      item.addEventListener("click", closeMenu);
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yuvenlife-footer"]) return;
  try {
    
function setupYuvenlifeFooter(){const footer=document.getElementById('yl-footer-v2');if(!footer||footer.dataset.ready)return;footer.dataset.ready='true';const media=matchMedia('(max-width:760px)');const groups=footer.querySelectorAll('details');const sync=()=>groups.forEach(group=>{group.open=!media.matches});sync();media.addEventListener('change',sync);groups.forEach(group=>group.querySelector('summary').addEventListener('click',event=>{if(!media.matches)event.preventDefault()}))}setupYuvenlifeFooter();document.addEventListener('shopify:section:load',setupYuvenlifeFooter);

  } catch(e) { console.error(e); }
})();
})();
